import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../../../Components/Popup/Tooltip';
import NcziQueuePanel from './NcziQueuePanel';
import Text from '../../../../Components/Base/Text/Text';
import {
	NcziMessage,
	useLazyNcziQueueQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import { useAppContext } from '../../../../Services/AppContext';

// @ts-ignore
import styles from './NcziQueue.module.scss';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';

interface Props {
	userId: string;
}

const NcziQueue: React.FC<Props> = props => {
	const [panelOpened, setPanelOpened] = useState<boolean>(false);
	const [getQueueList] = useLazyNcziQueueQuery();
	const [itemCount, setItemCount] = useState<number>(0);
	const [items, setItems] = useState<NcziMessage[]>([]);
	const { socket } = useAppContext();
	const { isAllowed } = useAclContext();

	const handleTogglePanel = () => {
		setPanelOpened(prevState => !prevState);
	};

	const updateList = async () => {
		const { items } = await getQueueList({
			userId: props.userId,
		}).unwrap();

		const queueItems = [];
		for (const item of items?.data || []) {
			if (item) {
				queueItems.push(item);
			}
		}

		setItemCount(items?.meta?.count || 0);
		setItems(queueItems);
	};

	useEffect(() => {
		socket.on('ncziMessageState', updateList);
		socket.on('updateQueue', updateList);
		return () => {
			socket.off('ncziMessageState', updateList);
			socket.off('updateQueue', updateList);
		};
	}, []);

	useEffectAsync(async () => {
		await updateList();
	}, [panelOpened]);

	if (!isAllowed('ezdravie_setup')) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<Tooltip
				trigger={
					<div onClick={handleTogglePanel} className={styles.toggleButton}>
						<FontAwesomeIcon icon={faListCheck} />
						{itemCount > 0 && <span className={styles.badge}>{itemCount}</span>}
					</div>
				}>
				<Text tx={'nczi.queue.title'} />
			</Tooltip>
			<NcziQueuePanel
				opened={panelOpened}
				onClose={handleTogglePanel}
				items={items}
			/>
		</div>
	);
};

export default NcziQueue;
